import { DIAGNOSIS_REVIEWED } from './general';

export const ASSESSMENT_REVIEW_INITIAL_STATE = {
  date_of_assessment: null,
  date_of_reassessment: null,
  clinical_interview_or_summary: '',
  is_diagnostic_reports_reviewed: DIAGNOSIS_REVIEWED.NONE,
  is_previous_assessment_reports_reviewed: false,
  is_previous_intervention_plans_and_treatment_plans_reviewed: false,
  is_reports_by_other_providers_reviewed: false,
  is_school_reports_reviewed: false,
  is_medical_reports_reviewed: false,
} as const;

export const ASSESSMENT_SUMMARY_INITIAL_STATE = {
  summary_assessment_result: '',
  summary_priorities_based_on_assessment: '',
  summary_observations_during_assessment: '',
} as const;
